import { render } from "./DailyPage.vue?vue&type=template&id=45c32e16"
import script from "./DailyPage.vue?vue&type=script&lang=js"
export * from "./DailyPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__